import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import loadable from "@loadable/component";

import "assets/css/pages/_home.scss";
import "assets/css/components/landing-refresh/_index.scss";

import {
  fetchReviewsPreview,
  selectReviewsPreviewStatus,
} from "../features/reviews/reviewsSlice";
import { selectLocalizationData } from "../features/localization/localizationSlice";
import { STATUS } from "../../shared/enums";
import FallbackPlaceholder from "../components/common/FallbackPlaceholder";
import HeroImagePreload from "../components/landing-refresh/HeroImagePreload";
import {fetchRegionalPrices, selectRegionalPricesStatus} from "../features/regionalPrices/regionalPricesSlice.js"

import { airInsightsStatic } from "../static-data/LandingRefresh/airInsightsStatic";
const [
  HeroAirSliderChristmas,
  AirbliviousVideo,
  SpoilerAlert,
  RejoiceVideo,
  MilaIntro,
  VideoContent,
  AirInsights,
  MilaOverlay,
  MilaChart,
  // TextBanner,
  MilaShowcase,
  // TextBlock,
  TwoSize,
  BackgroundTab,
  // PersonalizeFilter,
  AllMilaFilters,
  AwardsCredit,
  MilaFeeds,
  MilaTimeline,
  MilaOrder,
  MilaComparison,
] = [
  "HeroAirSliderChristmas",
  "AirbliviousVideo",
  "SpoilerAlert",
  "RejoiceVideo",
  "MilaIntro",
  "VideoContent",
  "AirInsights",
  "MilaOverlay",
  "MilaChart",
  // "TextBanner",
  "MilaShowcase",
  // "TextBlock",
  "TwoSize",
  "BackgroundTab",
  // "PersonalizeFilter",
  "AllMilaFilters",
  "AwardsCredit",
  "MilaFeeds",
  "MilaTimeline",
  "MilaOrder",
  "MilaComparison",
].map((component) =>
  loadable(() => import(`../components/landing-refresh/${component}`))
);

const LandingAir = ({
  route,
  headerRef,
  topBarRef,
  isOrder,
  setIsOrder,
  setIsMenuActive,
}) => {
  const dispatch = useDispatch();
  const localization = useSelector(selectLocalizationData);

  const regionalPricesStatus = useSelector(selectRegionalPricesStatus);
  const reviewsStatus = useSelector(selectReviewsPreviewStatus);

  useEffect(() => {
    dispatch(fetchRegionalPrices(localization));
  }, [ localization.region ]);

  useEffect(() => {
    if (reviewsStatus === STATUS.IDLE) dispatch(fetchReviewsPreview());
  }, [ reviewsStatus ]);

  const handleBuyNow = (e) => {
    e.preventDefault();
    setIsOrder(!isOrder);
    setIsMenuActive(false);
  };

  const comparison = {
    title: "She brings unmatched power-to-size performance.",
    subTitle:
      "Most purifiers are so much bigger than you realize... and you have no idea until they’re in your living room, towering over the family dog.",
    description: (
      <>
        <p>
          Mila delivers over 60% more power per pound, at half the size of your
          average air purifier. BOOM.
        </p>
      </>
    ),
  };

  return (
    <>
      <Helmet>
        <title>{route?.meta?.title}</title>
        <meta name="title" content="Mila Air Purifier - Best Smart Air Purifier for Home" />
        <meta name="description" content="Mila is the best smart air purifier for home use. Award-winning design, quieter performance, and powerful clean air for every room." />
      </Helmet>
      <HeroImagePreload region={localization.region} />
      <HeroAirSliderChristmas
        handleBuyNow={handleBuyNow}
        localization={localization}
        fallback={<FallbackPlaceholder />}
      />
      <AirbliviousVideo />
      <SpoilerAlert />
      <RejoiceVideo />
      <MilaIntro />
      <AirInsights data={airInsightsStatic} title="She safeguards your home from the dangers you can’t see or smell." />
      <MilaComparison {...comparison} />
      <MilaShowcase />
      <VideoContent />
      <div className="overlay-wrapper">
        <MilaOverlay />
        <MilaChart />
      </div>
      {/* <TextBlock /> */}
      <TwoSize localization={localization} />
      <BackgroundTab />
      <AllMilaFilters />
      {/* <PersonalizeFilter /> */}
      {/* <TextBanner /> */}
      <AwardsCredit />
      <MilaFeeds />
      <MilaTimeline localization={localization} />
      <MilaOrder localization={localization} />
    </>
  );
};

export default LandingAir;
